/* eslint-disable */
import { auth } from "@/plugins/auth/firebase.js";
import Cookie from "js-cookie";
import JWTDecode from "jwt-decode";
import moment from "moment";
import Swal from "sweetalert2";
import router from "@/router.js";

import axios from "axios";
import * as vars from "@/vars.json";

const httpAxios = axios.create({
  params: {}
});

export const users = {
  namespaced: true,
  state: {
    user: null,
    isLoading: false,
    profile: null,
    usersLst: [],
    taxes: [],
    registerCountry: "",
    collabRestriccions: null
  },
  mutations: {
    REGISTER_COUNTRY: (state, payload) => {
      state.registerCountry = payload;
    },
    SET_USER: (state, account) => {
      // console.log(account)
      state.user = account;
    },
    SET_LOADING: (state, payload) => {
      state.isLoading = payload;
    },
    SET_PROFILE: (state, payload) => {
      // console.log(payload)
      state.profile = payload;
    },
    SET_USERS_LIST: (state, payload) => {
      state.usersLst = payload;
    },
    SET_TAXES_LST: (state, lst) => {
      state.taxes = lst;
    },
    SET_COLLAB_RESTRIC: (state, payload) => {
      state.collabRestriccions = payload;
    }
  },

  actions: {
    deleteTax({ rootState }, idTax) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${rootState.users.user.uid}/taxes/${idTax}`)
          .remove()
          .then(
            res => {
              resolve(true);
            },
            error => {
              reject(false);
            }
          );
      });
    },
    loadTaxesLst({ commit, rootState }) {
      firebase
        .database()
        .ref(`users/${rootState.users.user.uid}/taxes`)
        .on(
          "value",
          snapshot => {
            const res = snapshot.val();
            if (res) {
              let arr = Object.keys(res).map(card => {
                const data = res[card];
                data.status = "ACTIVE";
                return { id: card, data: res[card] };
              });
              commit("SET_TAXES_LST", arr);
            } else {
              commit("SET_TAXES_LST", []);
            }
          },
          error => {
            commit("SET_TAXES_LST", []);
          }
        );
    },
    updateTax({ rootState }, data) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${rootState.users.user.uid}/taxes/${data.idTax}`)
          .set(data.tax)
          .then(function(res) {
            resolve(true);
          })
          .catch(err => {
            reject(false);
          });
      });
    },
    addTax({ rootState }, tax) {
      return new Promise((resolve, reject) => {
        let taxPath = firebase
          .database()
          .ref(`users/${rootState.users.user.uid}/taxes`);
        let idTax = taxPath.push().key;
        tax.id = idTax;
        firebase
          .database()
          .ref(`users/${rootState.users.user.uid}/taxes/${idTax}`)
          .update(tax)
          .then(res => {
            resolve(true);
          })
          .catch(err => {
            reject(false);
          });
      });
    },
    async clearUser({ commit, rootState }) {
      let uid;
      if (rootState.users.user.adminUid) {
        uid = rootState.users.user.adminUid;
      } else {
        uid = rootState.users.user.uid;
      }
      await firebase
        .database()
        .ref(`users/${rootState.users.user.uid}/profile`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/categories`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/inventory`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/notifications`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/transactions/sales`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/transactions/returns`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/transactions/orders`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/transactions/requests`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/providers`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/collaborators`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/transactions/clients`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/shops`)
        .off();
      await firebase
        .database()
        .ref(`users/${uid}/payment/subscription`)
        .off();
      commit("SET_USER", null);
      commit("SET_PROFILE", null);
      commit("SET_COLLAB_RESTRIC", null);
    },
    async login({ dispatch, commit }, account) {
      // // console.log(account)
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        auth
          .signInWithEmailAndPassword(account.email, account.password)
          .then(function(res) {
            auth.currentUser
              .getIdTokenResult()
              .then(async idTokenResult => {
                // Confirm the user is an Admin.
                // console.log(idTokenResult)
                if (idTokenResult.claims.role === "Colaborador") {
                  const token = idTokenResult.token;
                  // const user = {email: idTokenResult.claims.email, uid: idTokenResult.claims.adminUid, role:idTokenResult.claims.role}
                  // Cookie.set('access_token', {token, adminUid: idTokenResult.claims.adminUid, role:idTokenResult.claims.role});
                  const user = {
                    email: idTokenResult.claims.email,
                    uid: idTokenResult.claims.user_id,
                    role: idTokenResult.claims.role,
                    adminUid: idTokenResult.claims.adminUid || null,
                    country: idTokenResult.claims.country || null
                  };
                  const cookie = {
                    token: token,
                    uid: user.uid,
                    adminUid: user.adminUid,
                    role: user.role,
                    country: user.country || ""
                  };

                  // console.log(cookie, 'the cookie')

                  let isActive;
                  await firebase
                    .database()
                    .ref(
                      `users/${user.adminUid}/collaborators/${user.uid}/status/val`
                    )
                    .once("value", async snap => {
                      isActive = snap.val();
                      // console.log(snap.val())
                      if (isActive === "active") {
                        // console.log(user)
                        Cookie.set("access_token", cookie);
                        commit("SET_USER", user);
                        commit("SET_LOADING", false);
                        // dispatch('checkReactivatePlan').then(() => {
                        // actulizado status de las virtualshops
                        dispatch("updateVirtualShopsStatus").then(() => {
                          // actulizado status de las virtualshops
                        });
                        // })
                        resolve();
                      } else {
                        await auth.signOut();
                        commit("SET_LOADING", false);
                        reject({
                          code:
                            "Colaborador inactivo debido a las restricciones del plan"
                        });
                      }
                    });
                } else if (!idTokenResult.claims.role) {
                  // console.log('entre como admin?')
                  const token = idTokenResult.token;
                  const { email, uid } = auth.currentUser;
                  // console.log('setcookie')
                  Cookie.set("access_token", { token, adminUid: null });
                  commit("SET_USER", { email, uid });
                  commit("SET_LOADING", false);
                  resolve();
                  // dispatch('checkReactivatePlan').then(() => {
                  // actulizado status de las virtualshops
                  dispatch("updateVirtualShopsStatus").then(() => {
                    // actulizado status de las virtualshops
                  });
                  // })
                } else {
                  await auth.signOut();
                  commit("SET_LOADING", false);
                  reject({ code: "No puedes ingresar siendo vendedor" });
                }
              })
              .catch(error => {
                // console.log(error)
                commit("SET_LOADING", false);
                reject(error);
              });
          })
          .catch(error => {
            // console.log(error)
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },
    setCookie({ dispatch, commit }, token) {
      Cookie.set(
        "access_token",
        { token, adminUid: null },
        { path: "/" },
        { domain: ".migration-tender-staging.firebaseapp.com" }
      );
    },
    async register({ dispatch, commit, state }, account) {
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        auth
          .createUserWithEmailAndPassword(account.email, account.password)
          .then(function(res) {
            // console.log(res, account)
            // Update profile
            commit("REGISTER_COUNTRY", account.country);
            res.user
              .updateProfile({
                displayName: account.userName
              })
              .then(function(res) {
                // console.log(res)
                commit("SET_LOADING", false);
                resolve();
              })
              .catch(function(error) {
                commit("SET_LOADING", false);
                reject(error);
              });
          })
          .catch(error => {
            // console.log(error)
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },
    async forgotPass({ dispatch, commit }, account) {
      try {
        // // console.log(account);
        await auth.sendPasswordResetEmail(account.email);
      } catch (error) {
        throw error;
      }
    },
    loadProfile({ commit, state, dispatch }) {
      // console.log(state.user)
      let uid = state.user.uid;
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${uid}/profile`)
          .on(
            "value",
            function(snapshot) {
              let loadCommit = "SET_PROFILE";
              let profile = snapshot.val();
              if (profile && profile.showNotifSnack === undefined) {
                profile.showNotifSnack = true;
              }
              commit(loadCommit, profile);
              commit("SET_LOADING", false);

              resolve(profile);
            },
            function(error) {
              // console.log(error)
              // console.log('error en el catch')
              commit("SET_LOADING", false);
              dispatch("showErrorSessionExpired");
              reject();
            }
          );
      });
    },
    checkReactivatePlan({ rootState, dispatch, rootGetters }) {
      return new Promise((resolve, reject) => {
        let uid;
        if (rootState.users.user.adminUid) {
          uid = rootState.users.user.adminUid;
        } else {
          uid = rootState.users.user.uid;
        }
        dispatch("getRestrictions").then(async res => {
          // console.log(res)
          // si cumples con el plan de reactivate y si ya paso la fecha te reinicio
          if (res) {
            const finalPlanDay = moment(res.data.createdAt)
              .add(1, "month")
              .format("YYYY-MM-DD");
            const isAfter = moment().isAfter(finalPlanDay);
            if (res.data.name === "Plan Reactivate" && isAfter) {
              firebase
                .database()
                .ref(`users/${uid}/payment/subscription/data`)
                .update({
                  createdAt: moment().format("YYYY-MM-DD")
                });
              firebase
                .database()
                .ref(`users/${uid}/payment/subscription/restrictions`)
                .update({
                  currentAmountSale: 0
                });
              firebase
                .database()
                .ref(`users/${uid}/payment/subscription/status`)
                .set({
                  val: "active"
                });
              const shopsList = rootGetters["shops/getItems"];
              for (let i = 0; i < 1; i++) {
                firebase
                  .database()
                  .ref(`users/${uid}/shops/${shopsList[i].id}/status`)
                  .set({ val: "active" });
              }
            }
          }
          resolve(res);
        });
      });
    },
    updateVirtualShopsStatus({ rootState, dispatch }) {
      return new Promise((resolve, reject) => {
        let uid;
        if (rootState.users.user.adminUid) {
          uid = rootState.users.user.adminUid;
        } else {
          uid = rootState.users.user.uid;
        }
        dispatch("getRestrictions").then(async res => {
          await firebase
            .database()
            .ref(`users/${uid}/shops`)
            .once(
              "value",
              async function(snapshot) {
                await firebase
                  .database()
                  .ref(`virtualshop`)
                  .orderByChild("dataShop/uid")
                  .equalTo(uid)
                  .once("value", async snap => {
                    if (snap.val()) {
                      const vshops = Object.values(snap.val());
                      if (snapshot.val()) {
                        let shops = Object.values(snapshot.val());
                        if (res.status.val === "active") {
                          shops = Object.values(snapshot.val()).filter(
                            el => el.status.val !== "active"
                          );
                          for (const shop of shops) {
                            // console.log(shop)
                            const found = vshops.find(
                              el => el.dataShop.id === shop.id
                            );
                            if (found) {
                              firebase
                                .database()
                                .ref(`virtualshop/${shop.id}/dataShop`)
                                .update({
                                  status: "inactive"
                                });
                            }
                          }
                        } else {
                          for (const vshop of vshops) {
                            firebase
                              .database()
                              .ref(`virtualshop/${vshop.dataShop.id}/dataShop`)
                              .update({
                                status: "inactive"
                              });
                          }
                        }
                      }
                    }
                    resolve();
                  });
              },
              function(error) {
                reject(error);
              }
            );
        });
      });
    },
    async updateProfile({ commit, state }, payload) {
      commit("SET_LOADING", true);
      try {
        let uid = state.user.uid;
        await firebase
          .database()
          .ref(`users/${uid}/profile`)
          .update(payload)
          .then(function(res) {
            commit("SET_LOADING", false);
            // console.log(res)
          })
          .catch(function(err) {
            commit("SET_LOADING", false);
            throw err;
          });
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      }
    },
    loadCookies({ commit }) {
      // const parsed = cookieparser.parse(req.headers.cookie);
      // const accessTokenCookie = parsed.access_token;
      // // console.log('access_token : ', Cookie.get('access_token'));
      const accessTokenCookie = Cookie.get(
        "access_token",
        { path: "/" },
        { domain: "localhost" }
      );
      // console.log(accessTokenCookie, 'cookieee')
      if (!accessTokenCookie) {
        firebase.auth().onAuthStateChanged(function(currentUser) {
          // console.log(currentUser)
          if (currentUser) {
            auth.currentUser.getIdTokenResult().then(async idTokenResult => {
              if (idTokenResult.claims.role) {
                return;
              } else {
                const { email, uid } = currentUser;
                commit("SET_USER", { email, uid });
              }
            });
          } else {
            return;
          }
        });
      }
      const decoded = JWTDecode(accessTokenCookie);
      // console.log(decoded)
      if (decoded) {
        if (decoded.role) {
          commit("SET_USER", {
            uid: decoded.user_id,
            email: decoded.email,
            role: decoded.role,
            adminUid: decoded.adminUid,
            country: decoded.country || ""
          });
        } else {
          commit("SET_USER", {
            uid: decoded.user_id,
            email: decoded.email
          });
        }
      }
    },

    getRestrictions({ state, rootState }) {
      return new Promise((resolve, reject) => {
        let uid;
        if (rootState.users.user.adminUid) {
          uid = rootState.users.user.adminUid;
        } else {
          uid = rootState.users.user.uid;
        }
        const dataRestrictions = {
          uid: uid
        };
        httpAxios
          .post(vars.url + "/getUserRestrictions", dataRestrictions)
          .then(resRestrictions => {
            if (resRestrictions) {
              if (resRestrictions.data !== "") {
                if (resRestrictions.data.active) {
                  const today = new Date();
                  const dd = String(today.getDate()).padStart(2, "0");
                  const mm = String(today.getMonth() + 1).padStart(2, "0");
                  const yyyy = today.getFullYear();

                  let sendRes = {
                    data: {
                      amount: "0",
                      createdAt: yyyy + "-" + mm + "-" + dd,
                      currency: "cop",
                      description: "RESTRCCIONES INTERNAS",
                      idClient: "PERSONALIZADO",
                      interval: "NINGUNO",
                      interval_count: "0",
                      name: "PERSONALIZADO",
                      trialDays: resRestrictions.data.trialDays
                    },
                    id: "",
                    restrictions: resRestrictions.data,
                    status: {
                      val: "active"
                    }
                  };
                  if (resRestrictions.data.dateFrom) {
                    let nowTime = new Date().getTime();
                    let initTime = parseInt(resRestrictions.data.dateFrom);
                    let endTime = parseInt(resRestrictions.data.dateUntil);
                    if (nowTime >= initTime && nowTime <= endTime) {
                      resolve(sendRes);
                    }
                  } else {
                    resolve(sendRes);
                  }
                }
              }
            }
            firebase
              .database()
              .ref(`users/${uid}/payment/subscription`)
              .once(
                "value",
                snapshot => {
                  resolve(snapshot.val());
                },
                error => {
                  reject(error);
                }
              );
          });
      });
    },
    getCollaborators({ state, rootState }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/collaborators`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = [];
              if (res != null) {
                arr = Object.keys(res).map(card => {
                  return { id: card, data: res[card] };
                });
              }
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getUidUser({ state, rootState }) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        resolve(uid);
      });
    },
    addUserLocation({ rootState }, location) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        let stockTrash = firebase
          .database()
          .ref(`users/${uid}/profile/locations/`);
        let idLocation = stockTrash.push().key;
        location.id = idLocation;
        firebase
          .database()
          .ref(`users/${uid}/profile/locations/${idLocation}`)
          .update(location)
          .then(function(res) {
            resolve(true);
          })
          .catch(err => {
            reject(false);
          });
      });
    },
    addDefaultUserLocation({ rootState }, location) {
      return new Promise((resolve, reject) => {
        const uid = rootState.users.user.uid;
        firebase
          .database()
          .ref(`users/${uid}/profile/defaultlocation/`)
          .set(location)
          .then(function(res) {
            resolve(true);
          })
          .catch(err => {
            reject(false);
          });
      });
    },
    getUserLst({ commit }) {
      let data = {};
      httpAxios
        .post(vars.url + "/getUsers", data)
        .then(response => {
          if (response) {
            commit("SET_USERS_LIST", response.data.users);
          } else {
            commit("SET_USERS_LIST", []);
          }
        })
        .catch(error => {
          commit("SET_USERS_LIST", []);
        });
    },
    saveRestrictions({ commit }, data) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/saveRestrictions", data)
          .then(response => {
            if (response) {
              resolve(true);
            }
          })
          .catch(error => {
            // console.log(error)
            reject(false);
          });
      });
    },
    getUserRestrictions({ commit }, data) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/getUserRestrictions", data)
          .then(response => {
            if (response) {
              resolve(response);
            }
          })
          .catch(error => {
            // console.log(error)
            reject(false);
          });
      });
    },
    getDataSubscription({}, userId) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/getDataSubscriptionByUser", { userId: userId })
          .then(response => {
            if (response) {
              resolve(response.data);
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            // console.log(error)
            reject(false);
          });
      });
    },
    renewTrialDays({}, data) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/renewTrialDays", data)
          .then(response => {
            if (response) {
              resolve(response);
            }
          })
          .catch(error => {
            // console.log(error)
            reject(false);
          });
      });
    },
    getCollaboratorsByUser({ state, rootState }, userId) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${userId}/collaborators`)
          .once(
            "value",
            snapshot => {
              const res = snapshot.val();
              let arr = [];
              if (res != null) {
                arr = Object.keys(res).map(card => {
                  return { id: card, data: res[card] };
                });
              }
              resolve(arr);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    showErrorSessionExpired({ state, rootState, dispatch }) {
      Swal.fire({
        title: "Tu sesión expiró",
        text: "Tu sesión ha expirado, por favor vuelve a iniciar sesión.",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok"
      }).then(() => {
        dispatch("clearUser").then(function() {
          window.location.href = vars.domain2.redirection;
        });
      });
    },
    validatePemissionsCollab({ state, commit }, transaction) {
      return new Promise((resolve, reject) => {
        if (state.user.adminUid && !state.collabRestriccions) {
          const user = state.user;
          firebase
            .database()
            .ref(`users/${user.adminUid}/collaborators/${user.uid}/permissions`)
            .once(
              "value",
              snapshot => {
                const permissions = snapshot.val();
                commit("SET_COLLAB_RESTRIC", permissions);
                const cantAccess = permissions[transaction] || false;
                resolve(cantAccess);
              },
              error => {
                reject(false);
              }
            );
        } else if (state.user.adminUid) {
          const permissions = state.collabRestriccions[transaction] || false;
          resolve(permissions);
        } else {
          resolve(true);
        }
      });
    }
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
    getTaxes(state) {
      return state.taxes;
    }
  }
};
